import React, { useContext } from "react";
import styled from "styled-components";

import { UIStateContext } from "../../provider";
import UIManager from "../../service/ui-manager";
import { Box, Row, Col, Img } from "../../comps";

import { WINDOW_MODE } from "../../constants";
import {
  windowClose,
  windowIdle,
  windowMaximize,
  windowMinimize,
  logoText,
} from "../../theme/image";

const Wrapper = styled(Row)`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;background: ${({ theme }) => theme.color.GRAY_3};
  border-bottom:1px solid ${({ theme }) => theme.color.BLACK_4};
`;

const Content = styled(Row)`
  width: 90%;
  height: 90%;
  align-items: center;
  
  -webkit-app-region: drag;
`;

const IconWrapper = styled(Col)`
  height: 100%;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  -webkit-app-region: no-drag;
  &:hover {
    background: ${({ theme }) => theme.color.BLACK_0};
  }
  cursor: pointer;
`;

export default () => {
  const [UIState] = useContext(UIStateContext);
  const { windowMode } = UIState;

  return (
    <Wrapper>
      <Content>
        <IconWrapper>
          <Img height="80%" src={logoText} />
        </IconWrapper>
        <IconWrapper
          style={{ marginLeft: "auto" }}
          onClick={UIManager.minimizeWindow}
        >
          <Img height="80%" src={windowMinimize} />
        </IconWrapper>
        <IconWrapper
        style={{ marginLeft: "2%" }}
          onClick={
            windowMode === WINDOW_MODE.MAX
              ? UIManager.unMaximizeWindow
              : UIManager.maximizeWindow
          }
        >
          <Img
            height="80%"
            src={windowMode === WINDOW_MODE.MAX ? windowMaximize : windowIdle}
          />
        </IconWrapper>
        <IconWrapper style={{ marginLeft: "2%" }} onClick={UIManager.closeWindow}>
          <Img height="80%" src={windowClose} />
        </IconWrapper>
      </Content>
    </Wrapper>
  );
};
